import { Component, OnInit, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { LanguageLabels } from '@app/shared/services/language/language.service';
import { PosthogService } from '@app/shared/services/posthog/posthog.service';
import { SettingsService } from '@app/shared/services/settings/settings.service';
import { TranslocoService } from '@jsverse/transloco';
import { map } from 'rxjs';

@Component({
  selector: 'sbnb-general',
  templateUrl: './general.component.html',
  styleUrls: ['./general.component.scss'],
})
export class GeneralComponent implements OnInit {
  LanguageLabels = LanguageLabels;

  loading = true;
  saving = false;
  fieldsMeta: any;
  data: any;
  saveStatus: number;

  availableLanguages = signal([]);
  activeLanguage = signal('en');

  canManageBetaFeatures = toSignal(
    this.permissionsService.permissions.pipe(
      map((permissions) => permissions.is_admin || permissions.is_team_owner || permissions.all_features)
    )
  );

  canChangeLanguage$ = this.posthog.canChangeUiLanguage$;

  constructor(
    private settingsService: SettingsService,
    private authService: AuthenticationService,
    private permissionsService: UserPermissionsService,
    private translocoService: TranslocoService,
    private posthog: PosthogService
  ) {
    this.availableLanguages.set(this.translocoService.getAvailableLangs());
    this.activeLanguage.set(this.translocoService.getActiveLang());
  }

  ngOnInit() {
    this.settingsService.getGeneralSettings().subscribe((res) => {
      this.fieldsMeta = res.meta;
      this.data = res.data;

      if (!this.data.week_starts_on) {
        const preference = this.authService.getStartOfWeekPreference();

        let startOfWeek;

        if (preference === 0) {
          startOfWeek = 'sunday';
        } else {
          startOfWeek = 'monday';
        }

        this.data.week_starts_on = startOfWeek;
      }

      this.loading = false;
    });
  }

  save() {
    this.saveStatus = 1;
    this.saving = true;

    this.translocoService.setActiveLang(this.activeLanguage());

    this.settingsService.saveGeneralSettings(this.data).subscribe((res) => {
      if (res.error) {
        this.saveStatus = 1;
      } else {
        this.saving = false;
        this.saveStatus = 2;

        // Refresh the user object from the API
        this.authService.getUserDetails(true);

        setTimeout(() => {
          this.saveStatus = null;
        }, 2000);
      }
    });
  }
}
